export default "/assets/images/angry.4fb298cd715ca4a2.png";